import { ROLES } from '../../../Utils/constants'

/** Mirrors the server guard: SUPERADMIN, Trinity tenant (client 1) only; hidden while a super user views another tenant. */
const ALLOWED_CLIENT_IDS = ['1']

const { VITE_STRIPE_CHECKOUT_ENABLED } = import.meta.env

/** Also off unless the environment opts in with VITE_STRIPE_CHECKOUT_ENABLED=true. */
export const canUseStripeCheckout = (): boolean => {
  if (VITE_STRIPE_CHECKOUT_ENABLED !== 'true') return false
  if (sessionStorage.getItem('role') !== ROLES.SUPER_ADMIN) return false
  const actingForOtherTenant = sessionStorage.getItem('super_user') === 'true'
  const effective = actingForOtherTenant ? sessionStorage.getItem('selectedClientId') : sessionStorage.getItem('clientId')
  return ALLOWED_CLIENT_IDS.includes(String(effective))
}
